import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2DirectionSignsIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 20.447 21",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21),
    children: [/*#__PURE__*/jsx("path", {
      d: "m9.557.5v1.333"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.557 7.167v2.667"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.557 15.167v5.333"
    }), /*#__PURE__*/jsx("path", {
      d: "m17.557 7.166h-14.667v-5.333h14.667l2.2 2.195a.667.667 0 0 1 0 .943z"
    }), /*#__PURE__*/jsx("path", {
      d: "m2.89 9.833h14.667v5.333h-14.667l-2.195-2.2a.667.667 0 0 1 0-.943z"
    })]
  });
};

export { PM2DirectionSignsIcon };
//# sourceMappingURL=direction-signs.js.map
